import { NumberInput } from '@mantine/core';
import { Information } from '@carbon/icons-react';
import { Tooltip } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';
import styles from './EventQrConfirmationWindowInput.module.scss';

const EventQrConfirmationWindowInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { qrConfirmationWindowMinutes } = values;
    const hasError = !qrConfirmationWindowMinutes || qrConfirmationWindowMinutes <= 0;

    const updateValue = (value: number | string) => {
        updateValues({
            ...values,
            qrConfirmationWindowMinutes: Number(value) || 60,
        });
    };

    return (
        <NumberInput
            id="event-qr-confirmation-window-input"
            label={(
                <span className={styles.labelWithTooltip}>
                    {intl.formatMessage(messages.label)}
                    <Tooltip
                        label={intl.formatMessage(messages.tooltip)}
                        align="bottom"
                    >
                        <Information size={16} />
                    </Tooltip>
                </span>
            )}
            placeholder={intl.formatMessage(messages.placeholder)}
            min={1}
            onChange={updateValue}
            value={qrConfirmationWindowMinutes}
            error={hasError ? intl.formatMessage(messages.error) : undefined}
            required
            radius="md"
            size="md"
        />
    );
};

const messages = defineMessages({
    label: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventQrConfirmationWindowInput.label',
        defaultMessage: 'Czas na potwierdzenie QR',
    },
    placeholder: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventQrConfirmationWindowInput.placeholder',
        defaultMessage: 'Minuty, np. 60',
    },
    error: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventQrConfirmationWindowInput.error',
        defaultMessage: 'Czas musi być większy od 0.',
    },
    tooltip: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventQrConfirmationWindowInput.tooltip',
        defaultMessage: 'To liczba minut od rozpoczęcia wydarzenia, w których uczestnik może potwierdzić obecność kodem QR i odebrać punkty.',
    },
});

export default EventQrConfirmationWindowInput;
